  import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import EChartsReact from 'echarts-for-react';

export default observer(function AgeDistribution({ currentAuthentication }) {

  const ages = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.ages, [currentAuthentication?.audience_information?.detailed_audience_stats?.ages])
  const topAgeGroup = useMemo(() => {
    return ages && Object.keys(ages)?.reduce((max, group) => ages[max] > ages[group] ? max : group, '')
  }, [ages])

  const genderByAge = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.gender_by_age, [currentAuthentication?.audience_information?.detailed_audience_stats?.gender_by_age])

  const option = useMemo(() => ({
    xAxis: {
      data: [
        `13-17${genderByAge ? `\n\n${(genderByAge?.[`13-17`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`13-17`]?.female * 100 || 0).toFixed(1)}% F` : ''}`,
        `18-24${genderByAge ? `\n\n${(genderByAge?.[`18-24`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`18-24`]?.female * 100 || 0).toFixed(1)}% F` : ''}`,
        `25-34${genderByAge ? `\n\n${(genderByAge?.[`25-34`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`25-34`]?.female * 100 || 0).toFixed(1)}% F` : ''}`,
        `35-44${genderByAge ? `\n\n${(genderByAge?.[`35-44`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`35-44`]?.female * 100 || 0).toFixed(1)}% F` : ''}`,
        `45-64${genderByAge ? `\n\n${(genderByAge?.[`45-64`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`45-64`]?.female * 100 || 0).toFixed(1)}% F` : ''}`,
        `65+${genderByAge ? `\n\n${(genderByAge?.[`65+`]?.male * 100 || 0).toFixed(1)}% M\n${(genderByAge?.[`65+`]?.female * 100 || 0).toFixed(1)}% F` : ''}`
      ],
      axisLabel: {
        interval: 0,
      },
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
    },
    yAxis: {
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false }
    },
    series: [
      {
        // Total age distribution bar (background)
        type: 'bar',
        z: 0,
        barWidth: '60%',
        data: ['13-17', '18-24', '25-34', '35-44', '45-64', '65-'].map(ageGroup => ({
          value: +(ages?.[ageGroup] * 100).toFixed(2),
          label: { show: true, position: 'top', formatter: '{c}%' },
          itemStyle: {
            barBorderRadius: [10, 10, 0, 0],
            borderWidth: 1,
            borderType: 'solid',
            borderColor: '#2CCDB4',
            color: '#2CCDB4',
          }
        }))
      },
      {
        // Female distribution
        type: 'bar',
        stack: 'gender',
        z: 1,
        barWidth: '60%',
        barGap: '-100%',
        data: ['13-17', '18-24', '25-34', '35-44', '45-64', '65+'].map(ageGroup => ({
          value: +(genderByAge?.[ageGroup]?.female * 100 || 0).toFixed(1),
          itemStyle: { color: '#2CCDB4' },
          emphasis: {
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}% F'
            }
          }
        }))
      },
      {
        // Male distribution
        type: 'bar',
        stack: 'gender',
        z: 1,
        barWidth: '60%',
        barGap: '-100%',
        data: ['13-17', '18-24', '25-34', '35-44', '45-64', '65+'].map(ageGroup => ({
          value: +(genderByAge?.[ageGroup]?.male * 100 || 0).toFixed(1),
          itemStyle: { color: '#C1F6EE', barBorderRadius: [10, 10, 0, 0] },
          emphasis: {
            label: {
              show: true,
              position: 'inside',
              formatter: '{c}% M'
            }
          }
        }))
      },
    ],
    grid: {
      left: 20,
      right: 20,
      top: 30,
      bottom: '0%',
      containLabel: true
    },
    textStyle: {
      fontSize: 14
    },
  }), [ages, genderByAge])

  return (
    <div className="w-full flex bg-white dark:bg-rb-dark-mode p-4 rounded-lg col-span-3">
      <div className="w-1/4 border-r-1 border-gray-200 dark:border-rb-dark-mode-lighter mr-4 flex pr-6 flex-col justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">Age Distribution</p>
        <div className="w-full p-4 flex flex-col items-center justify-center bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-xl">
          <p className="font-bold text-gray-300 dark:text-gray-400">Top age group</p>
          <p className="font-bold text-5xl dark:text-white">{topAgeGroup}</p>
        </div>
      </div>
      <EChartsReact option={option} style={{ width: '100%', height: '100%' }} />
    </div>
  )
})
